// src/firebase.js
// Import the functions you need from the Firebase SDKs
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence, onAuthStateChanged, onIdTokenChanged, sendEmailVerification } from "firebase/auth";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDn5CXORw7CckMIF2xnZDwoY5x4HRAWLd8",
  authDomain: "xray-predictor-330c2.firebaseapp.com",
  projectId: "xray-predictor-330c2",
  storageBucket: "xray-predictor-330c2.firebasestorage.app",
  messagingSenderId: "1044129205757",
  appId: "1:1044129205757:web:2e6346ef74dfddd2989d94",
  measurementId: "G-GGS02CTPSX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Set session persistence to browser session (clears on browser close)
setPersistence(auth, browserSessionPersistence).catch((error) => {
  console.error("Error setting auth persistence:", error);
});

// Session timeout - automatically sign out after inactivity (30 minutes)
let inactivityTimeout;
const INACTIVITY_TIME = 30 * 60 * 1000; // 30 minutes

export const setupInactivityDetection = () => {
  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(() => {
      console.log('User inactive for 30 minutes, signing out');
      auth.signOut();
    }, INACTIVITY_TIME);
  };

  // Reset timer on user activity
  window.addEventListener('mousemove', resetInactivityTimer);
  window.addEventListener('keypress', resetInactivityTimer);
  window.addEventListener('click', resetInactivityTimer);
  
  // Initial setup
  resetInactivityTimer();

  return () => {
    // Cleanup function
    window.removeEventListener('mousemove', resetInactivityTimer);
    window.removeEventListener('keypress', resetInactivityTimer);
    window.removeEventListener('click', resetInactivityTimer);
    clearTimeout(inactivityTimeout);
  };
};

// Token refresh mechanism
let refreshTokenInterval;
export const setupTokenRefresh = () => {
  onIdTokenChanged(auth, async (user) => {
    if (user) {
      // Setup periodic token refresh - refresh token every 50 minutes
      // Firebase tokens usually expire after 1 hour
      clearInterval(refreshTokenInterval);
      refreshTokenInterval = setInterval(async () => {
        const tokenResult = await user.getIdTokenResult(true); // Force refresh
        console.log('Token refreshed successfully');
      }, 50 * 60 * 1000); // 50 minutes
    } else {
      clearInterval(refreshTokenInterval);
    }
  });

  return () => {
    clearInterval(refreshTokenInterval);
  };
};

// Audit logging for authentication events
export const logAuthEvent = async (eventType, details) => {
  try {
    await addDoc(collection(db, 'auth_logs'), {
      eventType,
      details,
      timestamp: serverTimestamp(),
      userId: auth.currentUser?.uid || 'anonymous',
      userEmail: auth.currentUser?.email || 'anonymous',
    });
  } catch (error) {
    console.error('Error logging auth event:', error);
  }
};

// Verify user's email
export const verifyEmail = async (user) => {
  try {
    await sendEmailVerification(user);
    return { success: true };
  } catch (error) {
    console.error('Error sending verification email:', error);
    return { success: false, error };
  }
};

// Notify user about status change
export const notifyStatusChange = async (userId, newStatus) => {
  try {
    const sendStatusNotification = httpsCallable(functions, 'sendStatusNotification');
    return await sendStatusNotification({ userId, newStatus });
  } catch (error) {
    console.error('Error sending status notification:', error);
    return { success: false, error };
  }
};